import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/next/node_modules/@sanity/next-loader/dist/client-components/live-stream.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/next/node_modules/@sanity/next-loader/dist/client-components/live.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/next/node_modules/next-sanity/dist/visual-editing/client-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/next/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/next/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/next/src/components/global/Breadcrumbs/Breadcrumbs.module.scss");
;
import(/* webpackMode: "eager" */ "/vercel/path0/next/src/components/_Blog/PostHero/PostHero.module.scss");
;
import(/* webpackMode: "eager" */ "/vercel/path0/next/src/components/ui/ReadingTime/ReadingTime.module.scss");
;
import(/* webpackMode: "eager" */ "/vercel/path0/next/src/components/_Blog/PostContent/ImageGrid/ImageGrid.module.scss");
;
import(/* webpackMode: "eager" */ "/vercel/path0/next/src/components/_Blog/PostContent/Quote/Quote.module.scss");
;
import(/* webpackMode: "eager" */ "/vercel/path0/next/src/components/_Blog/PostContent/OrderedList/OrderedList.module.scss");
;
import(/* webpackMode: "eager" */ "/vercel/path0/next/src/components/_Blog/PostContent/PostContent.module.scss");
